import { AccountTeam } from "./accountTeam";

export class Team {
    id: number;
    rodeoId: number;
    name: string;
    maleOnly: boolean;
    femaleOnly: boolean;
    points: number;

    contestants: AccountTeam[] = [];

    constructor() {
        this.contestants = [];
    }
}


// WEBPACK FOOTER //
// ./src/model/team.ts